webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(111);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuefire = __webpack_require__(126);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _vueMaterial = __webpack_require__(125);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	__webpack_require__(114);
	
	var _App = __webpack_require__(123);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuefire2.default);
	
	_vue2.default.use(_vueMaterial2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 112:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(117);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toastr = __webpack_require__(122);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: 'AIzaSyBartoXcvlmH1wu6lLuFXcpGEqiSjIoXng',
	  authDomain: 'giftbox-40985.firebaseapp.com',
	  databaseURL: 'https://giftbox-40985.firebaseio.com',
	  storageBucket: 'giftbox-40985.appspot.com',
	  messagingSenderId: '907745758023'
	};
	
	var app = _firebase2.default.initializeApp(config);
	
	var db = app.database();
	
	var userIsLoggedIn = null;
	var userID = null;
	
	app.auth().onAuthStateChanged(function (user) {
	  if (user) {
	    userIsLoggedIn = true;
	    userID = user.uid;
	    console.log(userID);
	  } else {
	    userIsLoggedIn = false;
	  }
	});
	
	var giftboxRef = db.ref('users/adeREuCBciMCfVVxKA1N1ZSrNC62/giftbox');
	var receivedGiftRef = db.ref('users/adeREuCBciMCfVVxKA1N1ZSrNC62/received_gifts');
	exports.default = {
	  name: 'app',
	  firebase: {
	    giftbox: giftboxRef,
	    gifthistory: receivedGiftRef
	  },
	  data: function data() {
	    return {
	      newGift: {
	        currentAmount: '',
	        name: '',
	        need: '',
	        note: '',
	        picture: '',
	        timestamp: '',
	        totalPrice: '',
	        url: ''
	      },
	
	      settings: {
	        loginEmail: '',
	        loginPassword: ''
	      },
	      user: {}
	    };
	  },
	
	  methods: {
	    addGift: function addGift() {
	      this.newGift.timestamp = Date.now();
	      giftboxRef.push(this.newGift);
	
	      this.newGift.currentAmount = '';
	      this.newGift.name = '';
	      this.newGift.need = '';
	      this.newGift.note = '';
	      this.newGift.picture = '';
	      this.newGift.timestamp = '';
	      this.newGift.totalPrice = '';
	      this.newGift.url = '';
	
	      _toastr2.default.success('Gift added!');
	    },
	
	    removeGift: function removeGift(gift) {
	      giftboxRef.child(gift['.key']).remove();
	      _toastr2.default.success('Gift removed!');
	    },
	
	    removeGiftFromHistory: function removeGiftFromHistory(gift) {
	      receivedGiftRef.child(gift['.key']).remove();
	      _toastr2.default.success('Gift removed from history!');
	    },
	    receivedGift: function receivedGift(gift) {
	      var item = {
	        currentAmount: gift.currentAmount,
	        name: gift.name,
	        need: gift.need,
	        note: gift.note,
	        picture: gift.picture,
	        timestamp: gift.timestamp,
	        totalPrice: gift.totalPrice,
	        url: gift.url
	      };
	
	      receivedGiftRef.push(item);
	
	      giftboxRef.child(gift['.key']).remove();
	      _toastr2.default.success('Gift marked as received!');
	    },
	
	    calculatePercentFunded: function calculatePercentFunded(current, total) {
	      return Math.floor(current / total * 100 + 0.5);
	    },
	
	    formatDate: function formatDate(ts) {
	      return (0, _moment2.default)(ts).format('Do MMM YYYY');
	    },
	
	    isUserLoggedIn: function isUserLoggedIn() {
	      console.log(userIsLoggedIn);
	      _toastr2.default.info('User is logged in: ' + userIsLoggedIn);
	      return userIsLoggedIn;
	    },
	
	    logoutUser: function logoutUser() {
	      if (userIsLoggedIn) {
	        app.auth().signOut();
	        _toastr2.default.success('Logged out!');
	      } else {
	        _toastr2.default.warning('You are not logged in!');
	      }
	    },
	
	    loginUser: function loginUser() {
	      if (!userIsLoggedIn) {
	        app.auth().signInWithEmailAndPassword(this.settings.loginEmail, this.settings.loginPassword).then(function () {
	          _toastr2.default.success('Successfully logged in!');
	        }).catch(function (error) {
	          if (error) {
	            _toastr2.default.warning('Wrong email or password!<br>' + error);
	          }
	        });
	      } else {
	        _toastr2.default.warning('You are already logged in!');
	      }
	    }
	  }
	};

/***/ },

/***/ 113:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 114:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 121:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 3,
		"./af.js": 3,
		"./ar": 9,
		"./ar-dz": 4,
		"./ar-dz.js": 4,
		"./ar-ly": 5,
		"./ar-ly.js": 5,
		"./ar-ma": 6,
		"./ar-ma.js": 6,
		"./ar-sa": 7,
		"./ar-sa.js": 7,
		"./ar-tn": 8,
		"./ar-tn.js": 8,
		"./ar.js": 9,
		"./az": 10,
		"./az.js": 10,
		"./be": 11,
		"./be.js": 11,
		"./bg": 12,
		"./bg.js": 12,
		"./bn": 13,
		"./bn.js": 13,
		"./bo": 14,
		"./bo.js": 14,
		"./br": 15,
		"./br.js": 15,
		"./bs": 16,
		"./bs.js": 16,
		"./ca": 17,
		"./ca.js": 17,
		"./cs": 18,
		"./cs.js": 18,
		"./cv": 19,
		"./cv.js": 19,
		"./cy": 20,
		"./cy.js": 20,
		"./da": 21,
		"./da.js": 21,
		"./de": 23,
		"./de-at": 22,
		"./de-at.js": 22,
		"./de.js": 23,
		"./dv": 24,
		"./dv.js": 24,
		"./el": 25,
		"./el.js": 25,
		"./en-au": 26,
		"./en-au.js": 26,
		"./en-ca": 27,
		"./en-ca.js": 27,
		"./en-gb": 28,
		"./en-gb.js": 28,
		"./en-ie": 29,
		"./en-ie.js": 29,
		"./en-nz": 30,
		"./en-nz.js": 30,
		"./eo": 31,
		"./eo.js": 31,
		"./es": 33,
		"./es-do": 32,
		"./es-do.js": 32,
		"./es.js": 33,
		"./et": 34,
		"./et.js": 34,
		"./eu": 35,
		"./eu.js": 35,
		"./fa": 36,
		"./fa.js": 36,
		"./fi": 37,
		"./fi.js": 37,
		"./fo": 38,
		"./fo.js": 38,
		"./fr": 41,
		"./fr-ca": 39,
		"./fr-ca.js": 39,
		"./fr-ch": 40,
		"./fr-ch.js": 40,
		"./fr.js": 41,
		"./fy": 42,
		"./fy.js": 42,
		"./gd": 43,
		"./gd.js": 43,
		"./gl": 44,
		"./gl.js": 44,
		"./he": 45,
		"./he.js": 45,
		"./hi": 46,
		"./hi.js": 46,
		"./hr": 47,
		"./hr.js": 47,
		"./hu": 48,
		"./hu.js": 48,
		"./hy-am": 49,
		"./hy-am.js": 49,
		"./id": 50,
		"./id.js": 50,
		"./is": 51,
		"./is.js": 51,
		"./it": 52,
		"./it.js": 52,
		"./ja": 53,
		"./ja.js": 53,
		"./jv": 54,
		"./jv.js": 54,
		"./ka": 55,
		"./ka.js": 55,
		"./kk": 56,
		"./kk.js": 56,
		"./km": 57,
		"./km.js": 57,
		"./ko": 58,
		"./ko.js": 58,
		"./ky": 59,
		"./ky.js": 59,
		"./lb": 60,
		"./lb.js": 60,
		"./lo": 61,
		"./lo.js": 61,
		"./lt": 62,
		"./lt.js": 62,
		"./lv": 63,
		"./lv.js": 63,
		"./me": 64,
		"./me.js": 64,
		"./mi": 65,
		"./mi.js": 65,
		"./mk": 66,
		"./mk.js": 66,
		"./ml": 67,
		"./ml.js": 67,
		"./mr": 68,
		"./mr.js": 68,
		"./ms": 70,
		"./ms-my": 69,
		"./ms-my.js": 69,
		"./ms.js": 70,
		"./my": 71,
		"./my.js": 71,
		"./nb": 72,
		"./nb.js": 72,
		"./ne": 73,
		"./ne.js": 73,
		"./nl": 75,
		"./nl-be": 74,
		"./nl-be.js": 74,
		"./nl.js": 75,
		"./nn": 76,
		"./nn.js": 76,
		"./pa-in": 77,
		"./pa-in.js": 77,
		"./pl": 78,
		"./pl.js": 78,
		"./pt": 80,
		"./pt-br": 79,
		"./pt-br.js": 79,
		"./pt.js": 80,
		"./ro": 81,
		"./ro.js": 81,
		"./ru": 82,
		"./ru.js": 82,
		"./se": 83,
		"./se.js": 83,
		"./si": 84,
		"./si.js": 84,
		"./sk": 85,
		"./sk.js": 85,
		"./sl": 86,
		"./sl.js": 86,
		"./sq": 87,
		"./sq.js": 87,
		"./sr": 89,
		"./sr-cyrl": 88,
		"./sr-cyrl.js": 88,
		"./sr.js": 89,
		"./ss": 90,
		"./ss.js": 90,
		"./sv": 91,
		"./sv.js": 91,
		"./sw": 92,
		"./sw.js": 92,
		"./ta": 93,
		"./ta.js": 93,
		"./te": 94,
		"./te.js": 94,
		"./tet": 95,
		"./tet.js": 95,
		"./th": 96,
		"./th.js": 96,
		"./tl-ph": 97,
		"./tl-ph.js": 97,
		"./tlh": 98,
		"./tlh.js": 98,
		"./tr": 99,
		"./tr.js": 99,
		"./tzl": 100,
		"./tzl.js": 100,
		"./tzm": 102,
		"./tzm-latn": 101,
		"./tzm-latn.js": 101,
		"./tzm.js": 102,
		"./uk": 103,
		"./uk.js": 103,
		"./uz": 104,
		"./uz.js": 104,
		"./vi": 105,
		"./vi.js": 105,
		"./x-pseudo": 106,
		"./x-pseudo.js": 106,
		"./yo": 107,
		"./yo.js": 107,
		"./zh-cn": 108,
		"./zh-cn.js": 108,
		"./zh-hk": 109,
		"./zh-hk.js": 109,
		"./zh-tw": 110,
		"./zh-tw.js": 110
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 121;


/***/ },

/***/ 123:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(113)
	
	/* script */
	__vue_exports__ = __webpack_require__(112)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-46cf7b8e"
	
	module.exports = __vue_exports__


/***/ },

/***/ 124:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._c('md-tabs', {
	    attrs: {
	      "md-fixed": ""
	    }
	  }, [_vm._c('md-tab', {
	    attrs: {
	      "md-label": "My giftbox"
	    }
	  }, _vm._l((_vm.giftbox), function(gift) {
	    return _vm._c('md-card', [_vm._c('md-card-header', [_vm._c('h2', {
	      staticClass: "md-title"
	    }, [_vm._v("\n            " + _vm._s(gift.name) + "\n          ")]), _vm._v(" "), _vm._c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v("\n            $ " + _vm._s(gift.currentAmount) + " / $ " + _vm._s(gift.totalPrice) + "\n          ")])]), _vm._v(" "), _vm._c('md-card-content', [_vm._c('div', [_vm._v(_vm._s(gift.note))]), _vm._v(" "), _vm._c('div', [_vm._v("Need Rating: " + _vm._s(gift.need))]), _vm._v(" "), _vm._c('div', [_vm._v("Added on: "), _vm._c('time', {
	      attrs: {
	        "datetime": _vm.formatDate(gift.timestamp)
	      }
	    }, [_vm._v(_vm._s(_vm.formatDate(gift.timestamp)))])]), _vm._v(" "), _vm._c('div', [_vm._v("Funded: " + _vm._s(_vm.calculatePercentFunded(gift.currentAmount, gift.totalPrice)) + "%")]), _vm._v(" "), _vm._c('md-progress', {
	      attrs: {
	        "md-progress": _vm.calculatePercentFunded(gift.currentAmount, gift.totalPrice)
	      }
	    })], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
	      staticClass: "md-raised md-primary",
	      on: {
	        "click": function($event) {
	          _vm.receivedGift(gift)
	        }
	      }
	    }, [_vm._c('md-icon', [_vm._v("check")]), _vm._v(" "), _vm._c('md-tooltip', {
	      attrs: {
	        "md-delay": "500",
	        "md-direction": "bottom"
	      }
	    }, [_vm._v("Bought / Received")])], 1), _vm._v(" "), _vm._c('md-button', {
	      staticClass: "md-raised md-warn",
	      on: {
	        "click": function($event) {
	          _vm.removeGift(gift)
	        }
	      }
	    }, [_vm._c('md-icon', [_vm._v("delete")]), _vm._v(" "), _vm._c('md-tooltip', {
	      attrs: {
	        "md-delay": "500",
	        "md-direction": "bottom"
	      }
	    }, [_vm._v("Remove / Delete")])], 1)], 1)], 1)
	  })), _vm._v(" "), _vm._c('md-tab', {
	    attrs: {
	      "md-label": "Friend gifts"
	    }
	  }, [_vm._c('p', [_vm._v("Tab for friend gifts.")])]), _vm._v(" "), _vm._c('md-tab', {
	    attrs: {
	      "md-label": "Gift history"
	    }
	  }, _vm._l((_vm.gifthistory), function(gift) {
	    return _vm._c('md-card', [_vm._c('md-card-header', [_vm._c('h2', {
	      staticClass: "md-title"
	    }, [_vm._v("\n            " + _vm._s(gift.name) + "\n          ")]), _vm._v(" "), _vm._c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v("\n            $ " + _vm._s(gift.currentAmount) + " / $ " + _vm._s(gift.totalPrice) + "\n          ")])]), _vm._v(" "), _vm._c('md-card-content', [_vm._c('md-progress', {
	      attrs: {
	        "md-progress": _vm.calculatePercentFunded(gift.currentAmount, gift.totalPrice)
	      }
	    })], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
	      staticClass: "md-raised md-warn",
	      on: {
	        "click": function($event) {
	          _vm.removeGiftFromHistory(gift)
	        }
	      }
	    }, [_vm._c('md-icon', [_vm._v("delete")]), _vm._v(" "), _vm._c('md-tooltip', {
	      attrs: {
	        "md-delay": "500",
	        "md-direction": "bottom"
	      }
	    }, [_vm._v("Remove / Delete")])], 1)], 1)], 1)
	  })), _vm._v(" "), _vm._c('md-tab', {
	    attrs: {
	      "md-label": "Add gift"
	    }
	  }, [_vm._c('md-card', [_vm._c('md-card-content', [_vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("wallet_giftcard")]), _vm._v(" "), _vm._c('label', [_vm._v("Name:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.name),
	      expression: "newGift.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.name)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.name = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("speaker_notes")]), _vm._v(" "), _vm._c('label', [_vm._v("Note:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.note),
	      expression: "newGift.note"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.note)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.note = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("star_half")]), _vm._v(" "), _vm._c('label', [_vm._v("Need (1/3):")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.need),
	      expression: "newGift.need"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.need)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.need = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("image")]), _vm._v(" "), _vm._c('label', [_vm._v("Picture:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.picture),
	      expression: "newGift.picture"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.picture)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.picture = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("link")]), _vm._v(" "), _vm._c('label', [_vm._v("URL:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.url),
	      expression: "newGift.url"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.url)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.url = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("attach_money")]), _vm._v(" "), _vm._c('label', [_vm._v("Current amount:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.currentAmount),
	      expression: "newGift.currentAmount"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.currentAmount)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.currentAmount = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("attach_money")]), _vm._v(" "), _vm._c('label', [_vm._v("Total price:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGift.totalPrice),
	      expression: "newGift.totalPrice"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newGift.totalPrice)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newGift.totalPrice = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": function($event) {
	        _vm.addGift()
	      }
	    }
	  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _vm._c('md-tab', {
	    attrs: {
	      "md-label": "Settings"
	    }
	  }, [_vm._c('md-card', [_vm._c('md-card-content', [_vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("speaker_notes")]), _vm._v(" "), _vm._c('label', [_vm._v("Email:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settings.loginEmail),
	      expression: "settings.loginEmail"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.settings.loginEmail)
	    },
	    on: {
	      "input": function($event) {
	        _vm.settings.loginEmail = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("speaker_notes")]), _vm._v(" "), _vm._c('label', [_vm._v("Password:")]), _vm._v(" "), _vm._c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.settings.loginPassword),
	      expression: "settings.loginPassword"
	    }],
	    attrs: {
	      "type": "password"
	    },
	    domProps: {
	      "value": (_vm.settings.loginPassword)
	    },
	    on: {
	      "input": function($event) {
	        _vm.settings.loginPassword = $event
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": _vm.loginUser
	    }
	  }, [_vm._v("Login")]), _vm._v(" "), _vm._c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": _vm.logoutUser
	    }
	  }, [_vm._v("Logout")]), _vm._v(" "), _vm._c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": _vm.isUserLoggedIn
	    }
	  }, [_vm._v("isUserLoggedIn?")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('footer', {
	    staticClass: "py-3"
	  }, [_vm._c('div', {
	    staticClass: "container text-center"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col"
	  }, [_vm._c('div', [_vm._v("Copyright © 2013-2017 Georgi Yanev & Sofia Lindberg")]), _vm._v(" "), _vm._c('div', [_vm._c('i', {
	    staticClass: "fa fa-code",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" with "), _vm._c('i', {
	    staticClass: "fa fa-heart",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" for little Anton.")])])])])])
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.4068c798ae6d1b48e760.js